import { render, staticRenderFns } from "./AcordFormDialog.vue?vue&type=template&id=47b47be6&scoped=true&"
import script from "./AcordFormDialog.vue?vue&type=script&lang=ts&"
export * from "./AcordFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AcordFormDialog.vue?vue&type=style&index=0&id=47b47be6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b47be6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
